import { motion } from 'framer-motion';
import { forwardRef, chakra, } from '@chakra-ui/react';

const MotionBox = motion(
  forwardRef((props, ref) => <chakra.div ref={ref} {...props} />)
);

export { MotionBox };
